import type { WorkLedgerRow } from '../work-control/work-ledger-port';
import { dailyWorkRows, workLocalDate } from '../work-control/work-daily-register-model';

export type DashboardWorkStage = 'permit' | 'tbm' | 'patrol' | 'closeout';
export type DashboardWorkSelection = { row: WorkLedgerRow; day: string; stage: DashboardWorkStage };
export function dashboardWorkRows(rows: readonly WorkLedgerRow[], date: string) {
  return dailyWorkRows(rows.filter(row => row.lifecycle !== 'invalidated'), date, date, date).map(item => {
    const day = item.row.register?.days?.[date];
    const patrols = item.row.register?.dailyEvidence?.patrols.filter(p => workLocalDate(p.at) === date);
    const issue = patrols?.some(p => p.actionRequired && !p.resolvedAt);
    const closed = item.closeout === '완료';
    const signed = !!day?.attendees && day.signed >= day.attendees;
    const state = closed ? '종료' : item.status === '작업 중지' ? '중지' : item.group === '진행' ? '진행' : '예정';
    return { ...item, state, signed, closed, stages: [
      { id: 'permit' as const, label: day?.approved ? '승인' : '미승인', tone: day?.approved ? 'done' : 'wait' },
      { id: 'tbm' as const, label: day ? `${day.signed} / ${day.attendees}명` : '미실시', tone: signed ? 'done' : 'wait' },
      { id: 'patrol' as const, label: patrols ? patrols.length ? `${patrols.length}회 · ${issue ? '미흡' : '양호'}` : '미실시' : '조회 필요', tone: issue ? 'wait' : patrols?.length ? 'done' : '' },
      { id: 'closeout' as const, label: closed ? '완료' : '미확인', tone: closed ? 'done' : '' },
    ] };
  });
}
